import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-border bg-background py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-146" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-147" data-mp="2vowj0erbpuyb">
        <div className="text-center" data-id="element-148" data-mp="39hmbn21cxy4e">
          <SectionHeading id="problem-title" data-id="element-149" data-mp="39gkzsvcip7lm">Does This Sound <span className="text-primary" data-id="element-150" data-mp="35gap55ds5t0f">Familiar?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-muted" data-id="element-151" data-mp="35iddzm375g3k">
            You work in a cement plant, a concrete laboratory, a batching plant, a precast yard or on site, but cement and
            concrete still feel like separate worlds. When someone talks about clinker quality, cement types, SCMs, mix
            design, curing, test results or durability problems, you can&apos;t connect all the pieces with confidence.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-xl border border-border bg-surface p-6 sm:p-8" data-id="element-152" data-mp="jeoi4dm8zupa">
          <p className="mb-5 inline-flex items-center gap-2 text-lg font-semibold text-foreground" data-id="element-153" data-mp="x6mls8x6wye2">
            <AlertTriangleIcon className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-154" data-mp="125pectvzhc55" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-155" data-mp="1c227nqnm9nzd">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-muted" data-id="element-156" data-mp="1bzobfeh7a5q8">
                <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-primary" aria-hidden="true" data-id="element-157" data-mp="1g2kzhkpieu1k" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-158" data-mp="3hviof5g612h8">
          <p className="mx-auto max-w-2xl text-lg font-semibold text-foreground" data-id="element-159" data-mp="p091nt6ovcfl">
            You don&apos;t need more scattered information.
          </p>
          <p className="mt-2 text-2xl font-bold tracking-tight text-primary sm:text-3xl" data-id="element-160" data-mp="k2h6mqaqza76">You need one organized system.</p>
        </div>
      </div>
    </section>;
}